export default "__VITE_ASSET__820cf541__"